// extracted by mini-css-extract-plugin
export default {"container":"login_container__4izRo","logo":"login_logo__Hay4S","logoText":"login_logoText__WVA4i","tm":"login_tm__CvVWd","login":"login_login__Ub7RI","info":"login_info__dORQu"};